import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Welcome.css';
import { BE_URL, httpGet } from '../../http';
import { Link } from 'react-router-dom';
import Loading from '../../components/loading/Loading';


const Welcome = (props) => {

    const [ estado, setEstado ] = useState({
        conf: {
            siteName: '',
            logo: ''
        },
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        loading: true,
        error: {}
    });

    useEffect(() => {
        
        

        try{
            getData();
        } catch(error) {
            console.log(error);
        };
        
    }, []);

    const getData = async () => {
        setEstado({
            ...estado,
            loading: true
        });

        let conf = await httpGet(BE_URL + '/ProveedoresWS/api/Configuration');

        setEstado({
            ...estado,
            conf: conf.data,
            loading: false
        })

        sessionStorage.setItem('estado', JSON.stringify({
            conf: conf.data,
            loading: true,
            error: {}
        }));

        return 0;

    }

    return(
        <div>
            { estado.loading &&
                <Loading />
            }
            { !estado.loading &&            
            <div className='welcome-content'>
                <div className="welcome-left-block">
                    <div>
                        <h2 className='welcome-h2'>Bienvenido al portal de Proveedores</h2>
                    </div>
                    <br />
                    <div>
                        <p className='welcome-p'>Este es el portal de {estado.conf.siteName} para Proveedores</p>
                        <br />
                        <p className='welcome-p'>Aquí usted prodrá:</p>
                        <ul>
                            <li className='welcome-li'>Ver sus comprobantes de pago</li>
                            <li className='welcome-li'>Ver sus notas de proveedor</li>
                            <li className='welcome-li'>Obtener certificados</li>
                        </ul>
                    </div>
                    <div>
                        <p className='welcome-h2'>Seleccione que desea hacer:</p>
                        <ul>
                            <li className='welcome-li'><Link to={{ pathname: '/login' }}>Ya tiene una cuenta de proveedor? Ingrese aqui</Link></li>
                            <li className='welcome-li'><Link to={{ pathname: '/signup' }}>Registrese como proveedor</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="welcome-right-block">
                    {/*<div className="welcome-messages-box">
                        <p>Señor proveedor.</p>

                        <p>Los certificados se encuentran en tramite, pronto estarán disponibles para que los pueda descargar</p>

                        <br />
                        <br />
                    </div>*/}
                </div>
            </div>
            }
        </div>
    );
}

export default Welcome;